class INTENT.widgets.CampaignGroupFillLimits
  @ATTR_NAME: "data-widget-fill-limits"

  fillDailyImpressionLimit = false
  fillDailyClickLimit = false

  constructor: (@el) ->
    @s = @.constructor

    @inputDailyImpLimit = $(document).find '[name="daily_impression_limit"]'
    valDailyImpLimit = @inputDailyImpLimit.val()
    if valDailyImpLimit !='' && parseInt(valDailyImpLimit) > 0
      fillDailyImpressionLimit = true
    else
      fillDailyImpressionLimit = false

    @inputDailyClickLimit = $(document).find '[name="daily_click_limit"]'
    valDailyClickLimit = @inputDailyClickLimit.val()
    if valDailyClickLimit !='' && parseInt(valDailyClickLimit) > 0
      fillDailyClickLimit = true
    else
      fillDailyClickLimit = false

    @checkFills()

    $(document).on "keyup", '[name="daily_impression_limit"]', (e) =>
      el = e.currentTarget
      if el.value != '' && parseInt(el.value) > 0
        fillDailyImpressionLimit = true
      else
        fillDailyImpressionLimit = false
      @checkFills()

    $(document).on "keyup", '[name="daily_click_limit"]', (e) =>
      el = e.currentTarget
      if el.value != '' && parseInt(el.value) > 0
        fillDailyClickLimit = true
      else
        fillDailyClickLimit = false
      @checkFills()

    $(document).on "click", '[id="campaigns_list_in_groups_show"]', (e) =>
      elC = e.currentTarget
      blockWithList = $(document).find("#campaigns_list_in_groups")
      blockISymbol = $(elC).find('i')
      if $(elC).hasClass('hidden_list')
        $(elC).removeClass('hidden_list')
        blockISymbol.removeClass('glyphicon-chevron-right').addClass('glyphicon-chevron-down')
        blockWithList.show(400)
      else
        $(elC).addClass('hidden_list')
        blockISymbol.removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-right')
        blockWithList.hide(400)
      e.preventDefault()


    @objectGroupIdInput = $(document).find '[id="object_group_id"]'
    @notificationStatusBlock = $(document).find '[id="campaign-groups-progress-block"]'
    @notificationLoadingBlock = $(document).find '[id="campaign-groups-loading-block"]'

    $.ajax({
      url: '/api/v3/campaigns/forecast_groups/'+@objectGroupIdInput.val(),
      method: 'get',
      success: (data, textStatus, jqXH) =>
        dailyLimitExceededCampaigns = []
        countAllGroupCampaign = 0;
        if data.hasOwnProperty('campaigns')
          for own idCampaign, value of data.campaigns
            countAllGroupCampaign++
            if value.status == 'DAILY_IMPRESSION_LIMIT_EXCEEDED' || value.status == 'DAILY_CLICK_LIMIT_EXCEEDED'
              dailyLimitExceededCampaigns.push({'id': idCampaign, 'name': value.name, 'advertiser_id': value.advertiser_id})
        if dailyLimitExceededCampaigns.length > 0
          #есть приостановленные кампании
          if dailyLimitExceededCampaigns.length == countAllGroupCampaign
            #все кампании приостановлены
            @notificationStatusBlock.html('<p>'+__('campaigns.group.message.daily-limit-warn')+'</p>')
            @notificationStatusBlock.css('display', 'block')
          else
            #только часть кампаний приостановлена
            oneManyCount = __('campaigns.group.message.daily-limit-warn.some_exceeded.one_company')
            oneManyStart = __('campaigns.group.message.daily-limit-warn.some_exceeded.one_company_start')
            oneManyStoped = __('campaigns.group.message.daily-limit-warn.some_exceeded.one_company_stop')
            if dailyLimitExceededCampaigns.length > 1
              oneManyCount = __('campaigns.group.message.daily-limit-warn.some_exceeded.many_company')
              oneManyStart = __('campaigns.group.message.daily-limit-warn.some_exceeded.many_company_start')
              oneManyStoped = __('campaigns.group.message.daily-limit-warn.some_exceeded.many_company_stop')
            html = "<p>" +
              __('campaigns.group.message.daily-limit-warn.some_exceeded', {':stoped': oneManyStoped, ':count_exceed': dailyLimitExceededCampaigns.length, ':count_all': countAllGroupCampaign, ':one_many_company': oneManyCount}) +
              " " + oneManyStart +
              "</p>"
            html += '<div><span style="cursor: pointer;"><a class="with-glyph hidden_list" id="campaigns_list_in_groups_show" href="javascript:void(0)"><i class="glyphicon glyphicon-chevron-right"></i>&nbsp;'+__('campaigns.group.message.daily-limit-warn.show.list_exceed_company')+'</a></span></div>';
            html += '<div style="display: none;" id="campaigns_list_in_groups">'
            for own idCampaignEx, valueEx of dailyLimitExceededCampaigns
              html += '<p style="margin:10px 0 0 30px;"><a href="/campaigns/advertisers/'+valueEx.advertiser_id+'/campaigns/edit/'+valueEx.id+'" target="_blank">'+valueEx.name+'&nbsp;('+valueEx.id+')'+'</a> </p>'
            html += '</div>'
            @notificationStatusBlock.html(html)
            @notificationStatusBlock.css('display', 'block')

      error: (jqXHR, textStatus, errorThrown) =>
        @notificationStatusBlock.css('display', 'block')
        @notificationStatusBlock.html('<p>'+jqXHR.responseJSON.error+'</p>')
      complete: =>
        @notificationLoadingBlock.css('display', 'none')
    })

  checkFills: () =>
    if fillDailyImpressionLimit || fillDailyClickLimit
      $('#fill-daily-limits').css('display','block')
    else
      $('#fill-daily-limits').css('display','none')
